import { isEmptyValue } from "../helper/isEmptyValue";
import type { SyncValidationRule } from "../types/validation";

export function required<TValue>(): SyncValidationRule<TValue> {
  return {
    name: "required",
    kind: "sync",
    dependencies: [],
    validate(value) {
      return isEmptyValue(value) ? { messageKey: "validation.required" } : undefined;
    },
  };
}
